module.exports = __webpack_public_path__ + "static/media/avatarDoctor.16922819.png";